<template>
  <div class="libraryStats-container app-container">
    <div class="libraryStats-header">
      <TabHeader
        :slideData="slideData"
        :tab="tab"
        @headerTabBack="headerTabBack"
      ></TabHeader>
    </div>
    <div class="libraryStats-main" v-bar>
      <div>
        <template v-for="item in chartData">
          <div :key="item.name" v-if="item.name === tab">
            <el-card shadow="always" :body-style="{ padding: '20px' }">
              <el-row :gutter="20">
                <el-col :span="4" v-if="tab !== 'total'">
                  <span class="libraryStats-header-label">总上行流量：</span>
                  <span class="libraryStats-header-value">{{
                    item.upVolumeTotalSize | renderSize
                  }}</span>
                </el-col>
                <el-col :span="4" v-if="tab !== 'total'">
                  <span class="libraryStats-header-label"
                    >总删除文件大小：</span
                  >
                  <span class="libraryStats-header-value">{{
                    item.downVolumeTotalSize | renderSize
                  }}</span>
                </el-col>
                <el-col :span="4">
                  <span class="libraryStats-header-label">总净新增大小：</span>
                  <span class="libraryStats-header-value">{{
                    item.totalSize | renderSize
                  }}</span>
                </el-col>
                <el-col :span="4">
                  <span class="libraryStats-header-label">总操作数：</span>
                  <span class="libraryStats-header-value">{{
                    item.totalCount
                  }}</span>
                </el-col>
                <el-col :span="4">
                  <span class="libraryStats-header-label">总用户数：</span>
                  <span class="libraryStats-header-value">{{
                    item.totalUserCount
                  }}</span>
                </el-col>
                <el-col :span="4">
                  <span class="libraryStats-header-label">总文件数：</span>
                  <span class="libraryStats-header-value">{{
                    item.totalDocumentIdCount
                  }}</span>
                </el-col>
              </el-row>
            </el-card>

            <div
              class="libraryStats-barChart"
              v-for="data in item.datas"
              :key="data.key"
            >
              <LibraryBarChart :xAxisData="item.dates" :statData="data" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import TabHeader from "@/components/tabHeader";
import LibraryBarChart from "./components/libraryBarChart.vue";
export default {
  components: {
    TabHeader,
    LibraryBarChart,
  },
  computed: {},
  data() {
    return {
      tab: "",
      slideData: [],
      chartData: [],
    };
  },
  methods: {
    headerTabBack(tab) {
      this.tab = tab.component;
    },
    async getStatData() {
      let res = await this.$http.getLibraryStats({ type: "day" });
      this.chartData = res.data;
      let slideData = [];
      for (let item of this.chartData) {
        slideData = [...slideData, { name: item.text, component: item.name }];
      }
      this.slideData = slideData;
      if (!this.tab) {
        this.tab = this.slideData[0].component;
      }
    },
  },
  mounted() {
    this.getStatData();
  },
};
</script>

<style lang="scss" scoped>
.libraryStats-container {
  .libraryStats-main {
    padding: 20px;
    .libraryStats-header-label {
      font-weight: bold;
    }
    .libraryStats-header-value {
      font-weight: bold;
      color: red;
    }
    .libraryStats-barChart {
      margin-top: 20px;
    }
  }
}
</style>
